
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Coins, Clock, TrendingUp } from 'lucide-react';

interface AnalysisCardInfoProps {
  estimatedTime: string;
  features: string[];
}

export function AnalysisCardInfo({ estimatedTime, features }: AnalysisCardInfoProps) {
  return (
    <>
      {/* Cost and Features Info */}
      <div className="flex items-center justify-center space-x-4 text-sm">
        <Badge variant="secondary" className="flex items-center space-x-1">
          <Coins className="h-3 w-3 text-yellow-500" />
          <span>30 Seshs</span>
        </Badge>
        <span className="text-muted-foreground">•</span>
        <div className="flex items-center space-x-1">
          <Clock className="h-3 w-3 text-blue-500" />
          <span className="text-blue-700">{estimatedTime}</span>
        </div>
        <span className="text-muted-foreground">•</span>
        <div className="flex items-center space-x-1">
          <TrendingUp className="h-3 w-3 text-green-500" />
          <span className="text-green-700">IA Avançada</span>
        </div>
      </div>

      {/* Features List */}
      {features.length > 0 && (
        <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-3">
          <h4 className="text-sm font-medium text-purple-900 mb-2 flex items-center gap-1">
            <CheckCircle className="h-4 w-4" />
            O que você receberá:
          </h4>
          <div className="grid grid-cols-2 gap-x-3 gap-y-1">
            {features.map((feature, index) => (
              <div key={index} className="text-xs text-purple-700 flex items-center gap-1">
                <span className="w-1 h-1 bg-purple-400 rounded-full flex-shrink-0"></span>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
